
































import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { ErrorCircleIcon, RefreshIcon, UploadIcon } from 'tdesign-icons-vue';

export default defineComponent({
  name: 'SyncTypeCard',
  props: {
    iconComponent: {
      type: String,
    },
    title: {
      type: String,
    },
    tooltips: {
      type: String,
      default: '',
    },
    wording: {
      type: String,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ErrorCircleIcon,
    RefreshIcon,
    UploadIcon,
  },
  setup(props, context) {
    const { iconComponent, title, tooltips, wording, isSelected, isDisabled } = toRefs(props);

    const shouldShowTooltips = computed(() => tooltips.value !== '');

    const methods = {
      handleClick() {
        if (isDisabled.value) {
          return;
        }
        context.emit('click');
      },
    };

    return {
      icon: iconComponent,
      titleWording: title,
      tooltipWording: tooltips,
      contentWording: wording,
      shouldShowTooltips,
      showSelected: isSelected,

      handleClick: methods.handleClick,
    };
  },
});
